import * as saleReportConstant from './constants'
export const saleReportNvkdRequest = (formData) => {
  return {
    type: saleReportConstant.SALE_REPORT_NVKD_REQUESTING,
    formData
  }
}

export const saleReportNvkdSuccess = (data) => {
  return {
    type: saleReportConstant.SALE_REPORT_NVKD_SUCCESS,
    data
  }
}

export const saleReportNvkdError = (error) =>{
  return {
    type: saleReportConstant.SALE_REPORT_NVKD_ERROR,
    error
  }
}
export const saleReportKhRequest = (formData) => {
  return {
    type: saleReportConstant.SALE_REPORT_KH_REQUESTING,
    formData
  }
}

export const saleReportKhSuccess = (data) => {
  return {
    type: saleReportConstant.SALE_REPORT_KH_SUCCESS,
    data
  }
}

export const saleReportKhError = (error) => {
  return {
    type: saleReportConstant.SALE_REPORT_KH_ERROR,
    error
  }
}
export const saleReportListRequest = (formData) => {
  return {
    type: saleReportConstant.SALE_REPORT_LIST_REQUESTING,
    formData
  }
}

export const saleReportListSuccess = (data) => {
  return {
    type: saleReportConstant.SALE_REPORT_LIST_SUCCESS,
    data
  }
}

export const saleReportListError = (error) => {
  return {
    type: saleReportConstant.SALE_REPORT_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: saleReportConstant.SALE_REPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: saleReportConstant.SALE_REPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: saleReportConstant.SALE_REPORT_EXPORT_XLS_ERROR,
    error
  }
}

export const saleReportNhomKhRequest = (formData, callback) => {
  return {
    type: saleReportConstant.SALE_REPORT_NHOMKH_REQUESTING,
    payload: formData,
    callback
  }
}

export const saleReportNhomKhSuccess = (data) => {
  return {
    type: saleReportConstant.SALE_REPORT_NHOMKH_SUCCESS,
    data
  }
}

export const saleReportNhomKhError = (error) => {
  return {
    type: saleReportConstant.SALE_REPORT_NHOMKH_ERROR,
    error
  }
}

export const saleReportKhByNhomRequest = (formData, callback) => {
  return {
    type: saleReportConstant.SALE_REPORT_KH_BY_NHOM_REQUESTING,
    payload: formData,
    callback
  }
}

export const saleReportKhByNhomSuccess = (data) => {
  return {
    type: saleReportConstant.SALE_REPORT_KH_BY_NHOM_SUCCESS,
    data
  }
}

export const saleReportKhByNhomError = (error) => {
  return {
    type: saleReportConstant.SALE_REPORT_KH_BY_NHOM_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/SaleReport/actions.js